import {Component, Input, OnInit} from '@angular/core';
import {consentSignature} from '../../../program/program-consents/consent-signature';
import {ProgramEnrollment} from '../../../eligible-patient';

@Component({
  selector: 'app-print-report-section',
  templateUrl: './print-report-section.component.html',
  styleUrls: ['./print-report-section.component.scss']
})
export class PrintReportSectionComponent implements OnInit {
  @Input() reportDetails: {};
  programEnrollment: ProgramEnrollment = new ProgramEnrollment();
  constructor() {
  }
  ngOnInit(): void {
  }
  consentSignature(consent: any) {
    return consentSignature(consent);
  }

  showConsentFrom(type: any) {
    if (type === 'care_team') return 'Sign consent via care team members device'
    if (type === 'verbally') return 'Patient verbally consents'
    if (type === 'paper') return 'Paper consent has been signed'
    if (type === 'mobile_portal') return 'Consent signed through mobile app or patient portal'

  }

}
